import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from 'classnames';

export const Step = ({
  active = false,
  complete = false,
  children,
  ...props
}: any) => {
  const classes = useStyles();

  const statusClasses = clsx({
    active: !!active,
    complete: !!complete,
  });

  const fullStepClasses = clsx(classes.root, statusClasses);

  function getStatusStyles() {
    return statusClasses;
  }

  function getStepStyles() {
    return fullStepClasses;
  }

  if (typeof children === 'function') {
    return children({
      getStatusStyles,
      getStepStyles,
      ...props,
    });
  }

  return <li className={fullStepClasses}>{children}</li>;
};

const useStyles = makeStyles(({ config, palette }) => ({
  root: {
    paddingBottom: '0.1rem',
    marginRight: '2rem',
    fontSize: config.textSizes.paragon,

    '&.active': {
      position: 'relative',
      color: `${palette.text.link} !important`,
      fontWeight: 600,
      borderBottom: `1px solid ${palette.common.cowbellBlue}`,

      'a&, & > a': {
        color: `${palette.text.link} !important`,
      },
    },

    '&.complete, &.complete > a': {
      color: palette.common.cowbellBlue,
    },
  },
}));
